import React from 'react'
import {IoMdPerson} from 'react-icons/io'


const TeamStandingsKey = ({teams}) => {
    return (
        <>

            <hr/>
            <div className="right standings-total">
                 Teams: {teams}
            </div>
            <div className="clear" />
        </>
    )
}

export default TeamStandingsKey